<template lang="pug">
	.script-builder-holder
		.script-builder
			Stepper(
				ref="stepper",
				:steps="activeSteps",
				:actions="stepper.actions",
				:initialSteps="stepper.currentStepIndexes",
				@step-changed="(s, v) => { stepper.currentStep = s; stepper.currentStepIndexes = v; }",
				:hideStepNumbers="true"
			)
				.flex-row.full-width.justify.padding
					.left.flex-row.space
					.right.flex-row.space
						DxButton(
							:text="attachToCreative ? $tCaption('Return to creative') : $tCaption('Return to list')",
							icon="back",
							type="default"
							@click="returnAction"
						)
						//DxButton(:text="$tCaption('Clear')", icon="close", @click="() => {}")

			DxScrollView(showScrollbar="always", direction="both").scroll-view
				.content
					template(v-if="stepper.currentStep")
						template(v-for="comp in stepper.currentStep.components")
							component(
								ref="currentComponent",
								v-bind="getProps(comp)",
								:is="comp.cmp()",
								:attachToCreative="attachToCreative",
								@data-changed="onStepDataChanged"
							)
</template>

<script>
	import _ from 'lodash';
	import NewScriptStep from './newScriptStep';
	import TestStep from './testStep';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import DxButton from 'devextreme-vue/button';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import Stepper from '@/view/proposal/Stepper.vue';

	export default {
		translationCategory: 'creative.ScriptBuilder',
		name: 'AiScriptBuilder',
		components: {
			DxScrollView,
			DxButton,
			DxDropDownButton,
			Stepper,
			NewScriptStep,
			TestStep,
		},
		props: ['attachToCreative'],
		data() {
			return {
				state: {newScript: {}, test: {}},
				stepper: {
					currentStepIndexes: [0, 0],
					currentStep: null
				},
				lastMapPosition: {},
				data: {},
				products: [],
				status: null,
			};
		},
		computed: {
			currentStep() {
				return this.$refs.stepper && this.$refs.stepper.currentSubStep;
			},
			activeSteps() {
				return this.steps
					.filter(f => !f.hidden || !f.hidden())
					.map(f => ({
						...f,
						steps: f.steps.filter(f => !f.hidden || !f.hidden())
					}));
			},
			steps() {
				return [
					{
						name: this.$tCaption('New AI Script'),
						icon: 'fas fa-scroll',
						steps: [
							{
								name: this.$tCaption('New AI Script'),
								components: [{cmp: () => NewScriptStep}],
								canNext: () => this.state.newScript.canNext
							},
						]
					},
					{
						name: this.$tCaption('Edit & Play suggestion'),
						icon: 'fas fa-play',
						steps: [
							{
								name: this.$tCaption('Edit & Play suggestion'),
								components: [{cmp: () => TestStep}],
								canNext: () => this.state.test.canNext
							}
						]
					}
				];
			}
		},
		mounted() {
			if (__DEBUG__)
				window.aiScript = this;
		},
		methods: {
			getProps(comp) {
				let result = {};
				const c = comp.cmp();
				if (c.name === 'newScriptStep') {
					result = this.state.newScript.data;
				}
				if (c.name === 'testStep') {
					result.suggestion = this.state.newScript.data?.selectedItems[0].text;
				}
				return result;
			},
			onStepDataChanged(e) {
				console.log(e);
				this.state[e.stepName] = {..._.omit(e, ['stepName'])}
			},
			returnAction() {
				this.$router.push(
					this.attachToCreative
						? {
							name: 'creative-detail',
							params: { creativeId: this.attachToCreative.creativeId },
						}
						: { name: 'creative-list' }
				);
			},
		},
	};
</script>

<style lang='scss'> //TODO копипаста стилией из /src/view/proposal/Builder.vue
@import "main/themes/generated/variables.base.scss";

.script-builder-holder {
	position: relative;
}

.script-builder {
	.products {
		margin: 0px 10px;

		> .product {
			padding: 5px 10px;
			background: rgba(0, 0, 0, 0.05);
			border-radius: 4px;
		}
	}

	.scroll-view {
		height: calc(100vh - 243px);
	}

	.dx-scrollable-scrollbar {
		> .dx-scrollable-scroll > .dx-scrollable-scroll-content {
			background: $base-accent-transparent;
		}
	}

	.content-block.header {
		padding-top: 5px;
		padding-left: 10px;
		font-size: 24px;

		.dx-button-text {
			font-size: 30px;
			font-weight: 100;
			letter-spacing: 0;
			text-transform: initial;
		}
	}
}

.dx-slider-handle .dx-tooltip-wrapper .dx-overlay-content .dx-popup-content {
	text-overflow: inherit !important;
}

.header-data {
	display: flex;
	align-items: center;
	overflow: auto;

	> .header {
		margin: 10px 20px 10px 40px;
	}
}

.widgets-row {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

.widgets-area {
	padding: 0px 4px 10px 4px;

	&.segment {
		background: #fff;
		margin: 4px;
		border-radius: 4px;
	}
}

.widgets-col {
	display: flex;
	flex-direction: column;
}

.widgets {
	width: 100%;
}

.widget {
	margin: 10px 5px 0px 5px;
	padding: 10px;

	.header {
		font-size: 16px;

		&.label {
			font-size: 12px;
			color: #c1c1c1;
			text-transform: uppercase;
		}
	}

	.data-statistic {
		font-weight: 400;
		font-size: 21.5px;
	}

	.data-vertical {
		display: flex;
		flex-direction: column;
		padding-top: 10px;

		> * {
			margin-bottom: 10px;
		}
	}

	&.large {
		width: 710px;
		max-width: 80%;
	}

	.data-horizontal {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
}

.dx-scrollable-scrollbar {
	z-index: 1000;
}
</style>
